export enum PersonalDetailsRedirectStepEnum {
  PersonalDetails = 1,
  AddressDetails,
  DocumentDetails,
}
